import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/main.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useState, useEffect } from 'react';

import { postuserstatus } from './components/API/ApiFunctions';
import Home from './components/pages/index'
import Layout from './components/pages/Layout';
import Dashboard from './components/pages/dashboard';
// import Signup from './components/pages/Signup';
// import Login from './components/pages/Login';
function App() { 

  const getUserGeolocationDetails =async () => {
    fetch(
        "https://geolocation-db.com/json/66216340-906a-11ec-bf81-0b6a6efc741f"
    )
        .then(response => response.json())
        .then(async(data) => {
          console.log("location",data);
          //  let k ={
          //     "ipAddress":data.IPv4,
          //     "algoAddress":addr,
          //     "networkType":"Algorand",
          //     "walletType":"MyAlgoWallet",
          //     "pageName":"Swap",
          // }
          // console.log("location",k);
          // datavalues.push(k)
          await postuserstatus(data.IPv4)
        }
         
        );
      //   await postuserstatus(datavalues);
      //   console.log("posted",datavalues)
};

useEffect(() =>{getUserGeolocationDetails()},[])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
          {/* <Route index element={<Home />} /> */}
          <Route path='home' element={<Home />} />
          {/* <Route path='dashboard' element={<Dashboard />} /> */}
          {/* <Route path="/signup" element={<Signup/>}/> */}
          {/* <Route path="/login" element={<Login/>}> */}

        {/* </Route> */}
        </Route>
      
      </Routes>
    </BrowserRouter>
  );
}

export default App;
